import { makeClassName } from "@hex-insights/core";
import { NumberFieldInputProps, NumberInput } from "@hex-insights/forms";
import { defaultCurrency } from "../../../../Utilities";
import styles from "./styles.module.css";

export type NumberWithCurrencyInputProps = { currency: string } & NumberFieldInputProps;

export function NumberWithCurrencyInput({ currency, className, ...props }: NumberWithCurrencyInputProps) {
	currency = currency || defaultCurrency;

	return (
		<label
			htmlFor={props.id ?? props.name}
			className={makeClassName(
				styles["number-with-currency-input__container"],
				props.disabled ? styles["number-with-currency-input__container--disabled"] : "",
				className,
			)}
		>
			<NumberInput {...props} className={styles["number-with-currency-input__input"]} />
			<span>{currency}</span>
		</label>
	);
}
